import type { Asset, Holding, Performance } from './types'

export const currency = new Intl.NumberFormat('en-MT', {
  style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2
})

export const compactCurrency = new Intl.NumberFormat('en-MT', {
  style: 'currency', currency: 'EUR', notation: 'compact', maximumFractionDigits: 1
})

export const formatCurrency = (value: number) => currency.format(value)
export const formatSignedCurrency = (value: number) => `${value >= 0 ? '+' : '−'}${currency.format(Math.abs(value))}`
export const formatPercent = (value: number) => `${value >= 0 ? '+' : '−'}${Math.abs(value).toFixed(2)}%`

export function holdingValue(holding: Holding, assets: Asset[]) {
  const asset = assets.find((item) => item.id === holding.assetId)
  return asset ? holding.quantity * asset.price : 0
}

export function holdingPerformance(holding: Holding, assets: Asset[]): Performance {
  const value = holdingValue(holding, assets)
  const cost = holding.quantity * holding.averageCost
  const amount = value - cost
  return { amount, percent: cost ? (amount / cost) * 100 : 0 }
}

export function portfolioSummary(holdings: Holding[], assets: Asset[], cash = 2173.88) {
  const investments = holdings.reduce((sum, item) => sum + holdingValue(item, assets), 0)
  const cost = holdings.reduce((sum, item) => sum + item.quantity * item.averageCost, 0)
  const gain = investments - cost
  return { investments, cash, total: investments + cash, gain, gainPercent: cost ? (gain / cost) * 100 : 0 }
}
